import { GetterTree } from "vuex";

import { RootState } from "@/types";

import UserState from "./constants";
import state from "./state";

export default {
  ...Object.keys(state).reduce((acc: GetterTree<UserState, RootState>, fieldName: string) => {
    acc[fieldName] = (state: UserState) => state[fieldName];
    return acc;
  }, {}),
};
